import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import PublicService from '@/service/public.service';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { documentCard } from '@/shared/model/document-card.model';
import { checkIfIsBase64Image, getDomainFromUrl, getHostName, onlyInLeft, timeDifference, toDataURL } from '@/util/ds-util';
import { namespace } from 'vuex-class';
import RefCardItem from '@/shared/cards/briefing/ref-card-item/ref-card-item.vue';

const briefingStore = namespace('briefingStore');
@Component({
  components: {
    'ref-item': RefCardItem,
    vueCustomScrollbar: vueCustomScrollbar,
  },
  methods: {
    getHostName,
  },
})
export default class RefUrlComponent extends Vue {
  @briefingStore.Getter
  public getAddingReferenceDocuments!: Array<any>;

  @briefingStore.Mutation
  public setAddingReferenceDocuments!: (payload: any) => void;

  @Inject('publicService')
  publicService: () => PublicService;

  scrollSettings = {
    wheelPropagation: false,
  };
  searchValue = '';
  isShowSpinner = false;
  previewModels = [];
  totalSelected = 0;
  selectedItems = [];
  checked = false;

  @Watch('getAddingReferenceDocuments')
  onGetAddingReferenceDocumentsChange() {
    if (this.getAddingReferenceDocuments === null || this.getAddingReferenceDocuments.length === 0) {
      this.selectedItems = [];
    }
  }

  bookmark(model) {
    this.setAddingReferenceDocuments([...this.getAddingReferenceDocuments, model]);
  }

  handleLinkToCheckDuplicated(urlInput: string): string {
    return urlInput
      .replace('https://www.', '')
      .replace('http://www.', '')
      .replace('https://', '')
      .replace('http://', '')
      .replace('www.', '');
  }

  preview() {
    if (!this.searchValue || this.searchValue == '') {
      return;
    }

    this.searchValue = this.searchValue.replace(' ', '');

    if (!this.searchValue || this.searchValue == '') {
      return;
    }

    // check more duplicated url before clone
    if (this.previewModels && this.previewModels.length > 0) {
      const tempUrlCheckDuplicated = this.handleLinkToCheckDuplicated(this.searchValue);

      for (const item of this.previewModels) {
        if (item.url.includes(tempUrlCheckDuplicated)) {
          this.resetPreview();
          return;
        }
      }
    }

    this.isShowSpinner = true;
    if (!this.previewModels) {
      this.previewModels = [];
    }
    // console.log('this.searchValue', this.searchValue);
    const lang = this.$store.getters.currentLanguage;
    this.publicService()
      .previewInfoByUrlV3({ url: this.searchValue, lang: lang })
      .then(async res => {
        this.isShowSpinner = false;
        if (!res.data) {
          this.$bvToast.toast(`${this.$t('newLearningCenter.addUrlErr')}`, {
            toaster: 'b-toaster-bottom-right',
            title: `${this.$t('newLearningCenter.warn')}`,
            variant: 'warning',
            solid: true,
            autoHideDelay: 4000,
          });
          return;
        }
        if (this.previewModels.length > 0 && res.data.url && this.previewModels.find(item => item.url == res.data.url)) {
          this.resetPreview();
          // no use toast more
          // this.$bvToast.toast(`${this.$t('newLearningCenter.urlExist')}`, {
          //   toaster: 'b-toaster-bottom-right',
          //   title: `${this.$t('newLearningCenter.warn')}`,
          //   variant: 'warning',
          //   solid: true,
          //   autoHideDelay: 4000,
          // });
          return;
        }

        // console.log(res.data);
        const obj = new documentCard();
        if (res.data.author) obj.author = res.data.author;
        else obj.author = getHostName(res.data.url);
        if (!obj.author) obj.author = getDomainFromUrl(res.data.url);
        obj.title = res.data.title ? res.data.title : '';
        obj.forcedClustering = false;
        obj.targetBpId = '';
        obj.path = res.data.url ? res.data.url : '';
        obj.content = '';
        obj.description = res.data.desc ? res.data.desc : '';
        obj.userKey = '';
        obj.keyword = res.data.keyword ? res.data.keyword : '';
        obj.lang = '';
        obj.type = 'URL';
        obj.searchType = 'WEB';
        obj.originDate = '';
        obj.parentDocId = '';
        obj.docType = 1;
        obj.isInsideGroup = false;
        obj.isGroup = false;
        // obj.img = res.data.image ? res.data.image : res.data.imageAlt ? res.data.imageAlt : '';
        // obj.image_uri = [res.data.image ? res.data.image : res.data.imageAlt ? res.data.imageAlt : ''];
        obj.image_uri = [
          res.data.image
            ? !checkIfIsBase64Image(res.data.image)
              ? res.data.image
              : ''
            : res.data.imageAlt
            ? !checkIfIsBase64Image(res.data.imageAlt)
              ? res.data.imageAlt
              : ''
            : '',
        ];
        obj.image_uri_thumbnail = '';
        obj.published_at = res.data.publicTime ? res.data.publicTime : '';
        obj.service_html = '';
        if (obj.addedAt) obj.addedAt = timeDifference(new Date(), new Date(res.data.publicTime));
        obj.url = res.data.url;
        if (res.data.favicon) obj.favicon = !checkIfIsBase64Image(res.data.favicon) ? res.data.favicon : '';
        else obj.favicon = '';
        obj.noConvertTime = true;
        obj.typeRemove = 'web';
        // obj.channel = 'URL';
        obj.channel = res.data.channel
          ? res.data.channel
          : res.data.link
          ? getHostName(res.data.link)
          : res.data.url
          ? getHostName(res.data.url)
          : res.data.path
          ? getHostName(res.data.path)
          : res.data.author
          ? getHostName(res.data.author)
          : '';

        obj.mediaType = ['WEB'];
        obj.docId = '';
        obj.create_date = new Date().toISOString();

        // console.log(obj);

        this.previewModels.push(obj);
        this.selectedItems.push(obj);

        this.bookmark(obj);
        this.resetPreview();
      })
      .catch(() => {
        this.$bvToast.toast(`${this.$t('newLearningCenter.addUrlErr')}`, {
          toaster: 'b-toaster-bottom-right',
          title: `${this.$t('newLearningCenter.warn')}`,
          variant: 'warning',
          solid: true,
          autoHideDelay: 4000,
        });
        this.resetPreview();
        this.isShowSpinner = false;
      })
      .finally(() => {
        this.isShowSpinner = false;
      });
  }

  resetPreview() {
    this.searchValue = null;
  }

  selectAll() {
    if (this.selectedItems.length === this.previewModels.length) this.selectedItems = [];
    else this.selectedItems = this.previewModels;
  }

  @Watch('selectedItems')
  watchSelectedItems() {
    this.totalSelected = this.selectedItems.length;
    this.$emit('setArrItemSelected', this.selectedItems, 'web');
  }

  @Watch('previewModels')
  dataChange() {
    const arrRight = this.checkArraySelected(true);
    if (arrRight && arrRight.length > 0) {
      for (const item of arrRight) {
        let i = 0;
        while (i < this.selectedItems.length) {
          if (this.selectedItems[i].link == item.link) {
            this.selectedItems.splice(i, 1);
            break;
          }
          i++;
        }
      }
    }

    this.selectedItems.length === this.previewModels.length ? $('#btnSelect').addClass('active') : $('#btnSelect').removeClass('active');
    this.totalSelected = this.selectedItems.length;
  }

  checkArraySelected(arg?) {
    if (arg) return onlyInLeft(this.selectedItems, this.previewModels, ['url']);
    return onlyInLeft(this.previewModels, this.selectedItems, ['url']);
  }

  setSelectedItems(newData) {
    this.selectedItems = newData;
    this.totalSelected = this.selectedItems.length;
    // this.selectedItems.length === this.previewModels.length ? $('#btnSelect').addClass('active') : $('#btnSelect').removeClass('active');
  }

  insertToMemory() {
    this.$root.$emit('cart-to-conlection', this.selectedItems, 'web');
  }

  deleteAll() {
    this.selectedItems.splice(0, this.selectedItems.length);
    // $('#btnSelect').removeClass('active');
  }

  removeCardReq(item) {
    const index = this.selectedItems.indexOf(item);
    if (index !== -1) this.selectedItems.splice(index, 1);
  }

  created() {
    this.$root.$on('delete-from-cart', this.removeCardReq);
    this.$root.$on('save-collection-finish', this.resetListSelected);
    this.$root.$on('clear-modal-data', this.clearModalData);
  }

  destroyed() {
    this.$root.$off('delete-from-cart', this.removeCardReq);
    this.$root.$off('save-collection-finish', this.resetListSelected);
    this.$root.$off('clear-modal-data', this.clearModalData);
  }

  resetListSelected() {
    this.selectedItems.splice(0, this.selectedItems.length);
  }

  selectAddingReferenceDocument(item) {
    let index = -1;

    if (this.selectedItems !== null && this.selectedItems.length > 0) {
      index = this.selectedItems.indexOf(item);
    }

    if (index !== -1) {
      this.selectedItems.splice(index, 1);
      this.removeReferenceDocument(item);
    } else {
      this.selectedItems.push(item);
      this.setAddingReferenceDocuments([...(this.getAddingReferenceDocuments ? this.getAddingReferenceDocuments : []), item]);
    }
  }

  removeCardInList(item) {
    const index = this.previewModels.indexOf(item);
    if (index !== -1) this.previewModels.splice(index, 1);
    this.removeCardReq(item);
    this.removeReferenceDocument(item);
  }

  removeReferenceDocument(item) {
    if (this.getAddingReferenceDocuments !== null && this.getAddingReferenceDocuments.length > 0) {
      const index = this.getAddingReferenceDocuments.indexOf(item);

      if (index !== -1) {
        this.getAddingReferenceDocuments.splice(index, 1);
        this.setAddingReferenceDocuments(this.getAddingReferenceDocuments);
      }
    }
  }

  clearModalData() {
    this.previewModels.splice(0, this?.previewModels?.length);
    this.resetPreview();
    this.resetListSelected();
  }

  openNewTab(url: string) {
    window.open(url, '_blank');
  }
}
